import { useCallback, useEffect, useState } from 'react';

type UseCopyToClipboardReturn = [boolean, () => void];

export const useCopyToClipboard = (value: string): UseCopyToClipboardReturn => {
  // A piece of state to keep track of if the user has copied the text to clipboard.
  const [didCopy, setDidCopy] = useState(false);

  const handleCopyText = useCallback(() => {
    navigator.clipboard.writeText(value).then(() => {
      setDidCopy(true);
    });
  }, [value]);

  useEffect(() => {
    if (didCopy === true) {
      const setDidCopyTimeout = setTimeout(() => {
        setDidCopy(false);
      }, 3000);

      return () => clearTimeout(setDidCopyTimeout);
    }

    return () => undefined;
  }, [didCopy]);

  return [didCopy, handleCopyText];
};
